<template>
  <div class="layouts">
    <!-- <Row type="flex" class="header" align="middle">
      <Icon size="32" type="ios-arrow-back" />
      <span class="font-16"> {{data.templateName}}</span>
    </Row>-->
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>
<style lang="less">
.header {
  padding: 0 20px;
  height: 50px;
  border-bottom: 1px solid rgb(232, 234, 236);
  margin-bottom: 30px;
  .templateName {
    font-size: 16px;
    margin-bottom: 15px;
  }
}

.groupName {
  position: relative;
  padding-left: 10px;
}
.groupName::before {
  position: absolute;
  left: 0;
  content: '';
  padding-left: 3px;
  width: 1px;
  top: 2px;
  height: 16px;
  background: #00a4a6;
  font-size: 12px;
}
.gary-text {
  color: #999;
}
</style>
<script>
import axios from 'axios';
import { mapMutations } from 'vuex';
import app_config from '@/commons/app_config';
export default {
  data() {
    return {
      data: {}
    };
  },
  mounted() {
    this.init_data();
  },
  methods: {
    ...mapMutations({
      set_form: 'set_form'
    }),
    async init_data() {
      try {
        let url = `${app_config.mainApiEndpoint}/rest/api/v1/recruitment/form/${this.$route.params.teamId}/${this.$route.params.registrationTemplateId}`;
        let res = await this.$http('GET', url, {}, true);
        this.data = res.data;
        document.title = res.data.title;
        this.set_form(res.data);
      } catch (e) {
        this.$Message.error({
          content: e.data.message,
          duration: 8
        });
      }
    }
  }
};
</script>
